"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = NotificationsRealtime;
const react_1 = __importStar(require("react"));
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const useWebSocket_1 = __importDefault(require("../../../hooks/useWebSocket"));
const useRealtimeChannel_1 = __importDefault(require("../../../hooks/useRealtimeChannel"));
const hook_1 = require("../../../redux/hook");
const react_router_dom_1 = require("react-router-dom");
const AUDIO_KEY = "audioConsentV1";
function NotificationsRealtime() {
    const { user } = (0, hook_1.useAppSelector)((state) => state.user);
    const socket = (0, useWebSocket_1.default)();
    const audioRef = (0, react_1.useRef)(null);
    const [consent, setConsent] = (0, react_1.useState)(localStorage.getItem(AUDIO_KEY) === "1");
    const [showGate, setShowGate] = (0, react_1.useState)(!consent);
    const navigate = (0, react_router_dom_1.useNavigate)();
    // 🎧 Initialisation du son
    (0, react_1.useEffect)(() => {
        const el = audioRef.current;
        if (!el)
            return;
        el.src = "/sounds/koussanar-notification.mp3";
        el.preload = "auto";
        el.loop = false;
        el.volume = 1;
    }, []);
    // Fonction centrale : lecture audio
    const playAlert = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        const el = audioRef.current;
        if (!el)
            return false;
        try {
            yield el.play();
            setShowGate(false);
            setConsent(true);
            localStorage.setItem(AUDIO_KEY, "1");
            return true;
        }
        catch (_a) {
            if (!consent)
                setShowGate(true);
            return false;
        }
    }), [consent]);
    // Helpers pour les dates
    const safeToDate = (input) => {
        if (input instanceof Date)
            return input;
        if (typeof input === "number")
            return new Date(input);
        if (typeof input === "string") {
            const iso = input.includes("T") ? input : input.replace(" ", "T");
            const d = new Date(iso);
            return isNaN(d.getTime()) ? null : d;
        }
        return null;
    };
    const formatTime = (d) => new Intl.DateTimeFormat("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    }).format(d);
    // Rendu selon le media_type
    const renderMedia = (media, media_type) => {
        const type = (media_type || "").toLowerCase().trim();
        if (!media || type === "null" || type === "" || type === "none" || media_type == null) {
            return react_1.default.createElement("p", { style: { margin: "8px 0" } }, media);
        }
        if (type === "image") {
            return (react_1.default.createElement("img", { src: media, alt: "Notification media", style: { maxWidth: "100%", borderRadius: 8, marginTop: 8 } }));
        }
        if (type === "audio") {
            return (react_1.default.createElement("audio", { controls: true, style: { width: "100%", marginTop: 8 } },
                react_1.default.createElement("source", { src: media, type: "audio/mpeg" }),
                "Votre navigateur ne supporte pas l\u2019audio."));
        }
        if (type === "video") {
            return (react_1.default.createElement("video", { controls: true, style: { width: "100%", borderRadius: 8, marginTop: 8 } },
                react_1.default.createElement("source", { src: media, type: "video/mp4" }),
                "Votre navigateur ne supporte pas la vid\u00E9o."));
        }
        return react_1.default.createElement("p", { style: { margin: "8px 0" } }, media);
    };
    // ✅ Callback de réception en temps réel
    const handleNewNotification = (0, react_1.useCallback)((data) => {
        var _a, _b, _c;
        const payload = typeof data === "string" ? JSON.parse(data) : data;
        const src = (_a = payload === null || payload === void 0 ? void 0 : payload.data) !== null && _a !== void 0 ? _a : payload;
        const { id, segment, content, categorie, severity, alert_color, media, media_type, created_at, is_scheduled, scheduled_datetime } = src;
        const dateObj = (_b = safeToDate(is_scheduled === 0 ? created_at : scheduled_datetime)) !== null && _b !== void 0 ? _b : new Date();
        const timeLabel = formatTime(dateObj);
        if (segment === 'tous' ||
            (segment === 'collaborateur' && ((user === null || user === void 0 ? void 0 : user.status) === 'collaborator' || (user === null || user === void 0 ? void 0 : user.status) === 'management')) ||
            (segment === 'admin' && ((_c = user === null || user === void 0 ? void 0 : user.status) === null || _c === void 0 ? void 0 : _c.includes('admin')))) {
            // 🔔 Son
            playAlert().then((ok) => {
                if (!ok && !consent) {
                    react_hot_toast_1.default.custom((t) => (react_1.default.createElement("div", { style: { background: "#000", color: "#fff", padding: 12, borderRadius: 8 } },
                        "Le son est bloqu\u00E9 par le navigateur.",
                        react_1.default.createElement("button", { onClick: () => {
                                playAlert().then((played) => {
                                    if (played) {
                                        localStorage.setItem(AUDIO_KEY, "1");
                                        setConsent(true);
                                        react_hot_toast_1.default.dismiss(t.id);
                                    }
                                });
                            }, style: {
                                marginLeft: 8,
                                padding: "4px 8px",
                                borderRadius: 6,
                                border: 0,
                                cursor: "pointer",
                            } }, "Activer le son"))), { duration: 6000 });
                }
            });
            // 🎯 Toast personnalisé
            react_hot_toast_1.default.custom((t) => (react_1.default.createElement("div", { style: {
                    background: "#fff",
                    color: "#111",
                    border: `2px solid ${alert_color || "#007bff"}`,
                    padding: 12,
                    borderRadius: 12,
                    boxShadow: "0 4px 10px rgba(0,0,0,.1)",
                    width: "320px",
                    maxWidth: "90vw",
                } },
                react_1.default.createElement("strong", { style: { color: alert_color || "#007bff" } },
                    categorie,
                    " \u2014 ",
                    severity),
                react_1.default.createElement("br", null),
                react_1.default.createElement("small", { style: { color: "#666" } }, timeLabel),
                react_1.default.createElement("div", { style: { marginTop: 8, fontSize: ".9rem", color: "#333" } },
                    content || "Nouvelle notification",
                    renderMedia(media, media_type)),
                react_1.default.createElement("div", { style: { marginTop: 8, display: "flex", justifyContent: "space-between", alignItems: "center" } },
                    react_1.default.createElement("button", { onClick: () => {
                            navigate(`/admin/mes-notifications/recues?open-pivot=${id}`);
                            react_hot_toast_1.default.dismiss(t.id);
                        }, style: {
                            background: "#20c997",
                            color: "white",
                            border: 0,
                            borderRadius: 6,
                            padding: "4px 10px",
                            cursor: "pointer",
                            fontSize: ".8rem",
                        } }, "Voir"),
                    react_1.default.createElement("button", { onClick: () => react_hot_toast_1.default.dismiss(t.id), style: {
                            background: alert_color || "#007bff",
                            color: "white",
                            border: 0,
                            borderRadius: 6,
                            padding: "4px 10px",
                            cursor: "pointer",
                            fontSize: ".8rem",
                        } }, "Fermer")))), { duration: Infinity, position: "top-right" });
        }
    }, [playAlert, consent]);
    // 🎯 Abonnement realtime via hook
    (0, useRealtimeChannel_1.default)({
        socket,
        channel: "notifications",
        event: "new.notification",
        onMessage: handleNewNotification,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("audio", { ref: audioRef, style: { display: "none" } }),
        showGate && (react_1.default.createElement("div", { onClick: () => __awaiter(this, void 0, void 0, function* () {
                const ok = yield playAlert();
                if (ok) {
                    localStorage.setItem(AUDIO_KEY, "1");
                    setConsent(true);
                }
            }), style: {
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,.6)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
                cursor: "pointer",
            } },
            react_1.default.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    e.stopPropagation();
                    const ok = yield playAlert();
                    if (ok) {
                        localStorage.setItem(AUDIO_KEY, "1");
                        setConsent(true);
                    }
                }), style: {
                    background: "#fff",
                    color: "#111",
                    border: 0,
                    borderRadius: 12,
                    padding: "10px 16px",
                    fontWeight: 700,
                } }, "Activer le son de notification")))));
}
